import { render, staticRenderFns } from "./choose-order.vue?vue&type=template&id=be50f3de&scoped=true&"
import script from "./choose-order.vue?vue&type=script&lang=js&"
export * from "./choose-order.vue?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&id=be50f3de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be50f3de",
  null
  
)

export default component.exports